export default __webpack_public_path__ + "static/media/neon_background.cfa16124.svg";